module.exports = __webpack_public_path__ + "img/013-border-2.d41d35fb.png";